export default {
  router: [
    {
      exact: true,
      path: '/settlement/invoicInfo',
      title: '开票信息',
    },
  ],
  title: '开票信息',
};
